import styled from "styled-components";
import { Box, Button as MuiButton } from "@mui/material";
import { DangerButtonProps } from "./types";

export const ButtonStyled = styled(MuiButton)`
  border-radius: 16px !important;
  padding: 10px 23px !important;
  height: 44px;
  flex-grow: 1;
  gap: 8px;
  box-shadow: none !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  .MuiButton-startIcon {
    margin: unset;
  }

  .MuiButton-endIcon {
    margin: unset;
  }

  transition: 0.1s linear all;
  &.MuiButtonBase-root {
  }
`;

export const PrimaryButtonStyled = styled.div`
  .MuiButtonBase-root {
    background: var(--royal-blue-color) !important;
    color: var(--pure-white-color) !important;
    &:hover {
      background: #9298a8 !important;
      color: var(--pure-white-color) !important;
      box-shadow:
        0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    }
  }
`;

export const LightButtonStyled = styled(Box)`
  .MuiButtonBase-root {
    /* width: 100%; */
    background: var(--pure-white-color) !important;
    color: var(--medium-gray-color) !important;
    border: 1px solid var(--muted-gray-color);
    &:hover {
      box-shadow:
        0px 2px 4px -1px rgba(0, 0, 0, 0.2),
        0px 4px 5px 0px rgba(0, 0, 0, 0.14),
        0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
    }
  }
`;

export const DangerButtonStyled = styled.div<DangerButtonProps>(
  ({ theme, variant = "filled" }) => {
    const isOutline = variant === "outline";

    return {
      ".MuiButtonBase-root": {
        background: isOutline
          ? "transparent !important"
          : `#B82424 !important`,
        color: isOutline
          ? `#B82424 !important`
          : `${theme.palette.common.white} !important`,
        border: isOutline ? `1px solid #B82424` : "none",
        "&:hover": {
          background: `#B82424 !important`,
          color: `${theme.palette.common.white} !important`,
          boxShadow:
            "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important",
        },
      },
    };
  }
);
